// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___3dqKU","list":"styles__list___1Sgoo"};